import cardAdd from '../images/icons/image-card-icons/card-icon-add-to-collection.svg';
import cardRemove from '../images/icons/image-card-icons/card-icon-remove.svg';
import cardCopy from '../images/icons/image-card-icons/card-icon-copy-image.svg';
import cardSave from '../images/icons/image-card-icons/card-icon-save-image.svg';
import cardZoom from '../images/icons/image-card-icons/card-icon-zoom-in.svg';
import cardShare from '../images/icons/image-card-icons/card-icon-share-to-community.svg';
import uploadIconWhite from "../images/icons/input-bar-icons/icon-input-bar-upload-white.svg";
import cardTag from '../images/icons/image-card-icons/card-icon-tag.svg';
import cardPublic from '../images/icons/image-card-icons/card-icon-public.svg';
import cardPrivate from '../images/icons/image-card-icons/card-icon-private.svg';
import { SiFacebook, SiTwitter, SiInstagram, SiTiktok, SiDiscord, SiLinkedin } from 'react-icons/si';
import electronBridge, { ipcRenderer } from '../utils/electronBridge';

export default function HowTo() {

    const openExternalUrl = (url) => {
        if (electronBridge.isElectron) {
            electronBridge.ipcRenderer.send("open-urlInExternal", url);
        } else {
            window.open(url, '_blank');
        }
    }

    return (
        <>
            <div className={"px-4 relative container mx-auto"}>
                <h1 className={"text-xl py-2 font-bold flex flex-row items-center"}>
                    <span>How To</span>
                    <hr className={"ml-2 flex-grow border border-white/40 bg-white/40"} />
                </h1>
                <div className={"bg-dark-blue/40 rounded-lg flex flex-col p-5 w-full mx-auto mt-10 mb-20"}>
                    <div className='text-2xl font-bold'>
                    Generated Image Options
                    <div className="my-10 flex flex-col xl:flex-row gap-0 xl:gap-24 ">
                            <div className="basis-1/3">
                                <div className={`group w-2/3 m-auto rounded-xl mb-10 xl:m-0 xl:w-full overflow-hidden relative`}>
                                    <img className={"w-full"} src="https://i.postimg.cc/Bvygwx6p/Bird.webp" alt='Help'/>
                                    <div
                                        className="flex bg-black/50 transition w-full h-full absolute top-0 left-0 flex-col justify-between">
                                        <div
                                            className="bg-dark-blue/30 backdrop-blur flex w-full flex-row flex-wrap justify-between self-center p-5 rounded gap-4">
                                            <div className={"flex flex-row gap-2 items-center"}>
                                                <button>
                                                    <img src={cardAdd} alt={"Add to Collection Icon"} />
                                                </button>
                                                <button className='w-7'>
                                                    <img src={cardPrivate} alt="Private Icon" />
                                                </button>
                                                <button className='w-7'>
                                                    <img src={cardPublic} alt="Public Icon" />
                                                </button>
                                                <button>
                                                    <img src={cardZoom} alt={"Zoom Icon"} />
                                                </button>
                                                <button>
                                                    <img src={cardCopy} alt={"Copy Icon"} />
                                                </button>
                                                <button>
                                                    <img src={cardSave} alt={"Save Icon"} />
                                                </button>
                                                <button>
                                                    <img src={uploadIconWhite} alt={"Upload Icon"} />
                                                </button>
                                                <button>
                                                    <img src={cardShare} alt={"Share Icon"} />
                                                </button>
                                                <button className="w-6">
                                                    <img src={cardTag} alt={"Tag Icon"} />
                                                </button>
                                            </div>
                                            <div>
                                                <button>
                                                    <img src={cardRemove} alt={"Remove Icon"} />
                                                </button>
                                            </div>
                                        </div>
                                        <p className="line-clamp-4 font-light text-base text-center p-5">Picture of a bird</p>
                                        <button className="text-center font-light text-sm p-4 hover:bg-dark-blue/30 hover:backdrop-blur">#35498655249871</button>
                                    </div>
                                </div>   
                            </div>
                            <div className="basis-1/4 flex flex-col gap-14 py-6">
                                <div className='grid grid-cols-5 gap-0 align-middle'>
                                    <img src={cardAdd} alt={"Add To Collection Icon"} className='w-8 m-auto col-span-1'/>
                                    <div className="border border-amber-500 w-full h-0.5 m-auto col-span-1"></div>
                                    <div className={" bg-white/20 border-2 border-white p-2 w-full rounded-lg text-base text-center col-span-3"}>
                                        Add Image to collection
                                    </div>
                                </div>
                                <button className='grid grid-cols-5 gap-0'>
                                    <img src={cardZoom} alt={"Zoom Icon"} className='w-8 m-auto col-span-1'/>
                                        <div className="border border-amber-500 w-full h-0.5 m-auto col-span-1"></div>
                                    <div className={"bg-white/20 border-2 border-white p-2 w-full rounded-lg text-base text-center col-span-3"}>
                                        Zoom in on image
                                    </div>
                                </button>
                                <button className='grid grid-cols-5 gap-0'>
                                    <img src={cardCopy} alt={"Copy Icon"} className='w-8 m-auto col-span-1'/>
                                        <div className="border border-amber-500 w-full h-0.5 m-auto col-span-1"></div>
                                    <div className={"bg-white/20 border-2 border-white p-2 w-full rounded-lg text-base text-center col-span-3"}>
                                        Copy image to clipboard
                                    </div>
                                </button>
                                <button className='grid grid-cols-5 gap-0'>
                                    <img src={cardSave} alt={"Save Icon"} className='w-8 m-auto col-span-1'/>
                                        <div className="border border-amber-500 w-full h-0.5 m-auto col-span-1"></div>
                                    <div className={"bg-white/20 border-2 border-white p-2 w-full rounded-lg text-base text-center col-span-3"}>
                                        Save image to disk
                                    </div>
                                </button>
                                <button className='grid grid-cols-5 gap-0'>
                                    <img src={cardPrivate} alt={"Save Icon"} className='w-8 m-auto col-span-1'/>
                                        <div className="border border-amber-500 w-full h-0.5 m-auto col-span-1"></div>
                                    <div className={"bg-white/20 border-2 border-white p-2 w-full rounded-lg text-base text-center col-span-3"}>
                                        Image is private
                                    </div>
                                </button>
                            </div>
                            <div className="basis-1/4 flex flex-col gap-14 py-6">
                                <div className='grid grid-cols-5 gap-0 align-middle'>
                                    <img src={uploadIconWhite} alt={"Upload Icon"} className='w-8 m-auto col-span-1'/>
                                    <div className="border border-amber-500 w-full h-0.5 m-auto col-span-1"></div>
                                    <div className={" bg-white/20 border-2 border-white p-2 w-full rounded-lg text-base text-center col-span-3"}>
                                        Upload a Image
                                    </div>
                                </div>
                                <button className='grid grid-cols-5 gap-0'>
                                    <img src={cardShare} alt={"Share Icon"} className='w-8 m-auto col-span-1'/>
                                        <div className="border border-amber-500 w-full h-0.5 m-auto col-span-1"></div>
                                    <div className={"bg-white/20 border-2 border-white p-2 w-full rounded-lg text-base text-center col-span-3"}>
                                        Share to community
                                    </div>
                                </button>
                                <button className='grid grid-cols-5 gap-0'>
                                    <img src={cardRemove} alt={"Delete Icon"} className='w-8 m-auto col-span-1'/>
                                        <div className="border border-amber-500 w-full h-0.5 m-auto col-span-1"></div>
                                    <div className={"bg-white/20 border-2 border-white p-2 w-full rounded-lg text-base text-center col-span-3"}>
                                        Remove image
                                    </div>
                                </button>
                                <button className='grid grid-cols-5 gap-0'>
                                    <img src={cardTag} alt={"Tag Icon"} className='w-8 m-auto col-span-1'/>
                                        <div className="border border-amber-500 w-full h-0.5 m-auto col-span-1"></div>
                                    <div className={"bg-white/20 border-2 border-white p-2 w-full rounded-lg text-base text-center col-span-3"}>
                                        Give an image a tag
                                    </div>
                                </button>
                                <button className='grid grid-cols-5 gap-0'>
                                    <img src={cardPublic} alt={"Save Icon"} className='w-8 m-auto col-span-1'/>
                                        <div className="border border-amber-500 w-full h-0.5 m-auto col-span-1"></div>
                                    <div className={"bg-white/20 border-2 border-white p-2 w-full rounded-lg text-base text-center col-span-3"}>
                                        Image is public
                                    </div>
                                </button>
                            </div>                     
                    </div>
                    </div>
                </div>
                <div className={"bg-dark-blue/40 rounded-lg flex flex-col p-5 w-full mx-auto my-20"}>
                    <h2 className='text-2xl font-bold'>Getting the offline toggle to work</h2>
                    <div className='my-5 text-xl font-medium p-2'>
                        1. Check if the localhost is running
                        <p className='font-light text-base ms-3'>First open the manager through the profile/login page and install/run a CPU/GPU server.</p>
                    </div>
                    <div className='my-5 text-xl font-medium p-2'>
                        2. Save the localhost settings
                        <p className='font-light text-base ms-3'>Then go to the settings page and make sure the Server Hostname input has http://localhost:[your port number]/ then click Save Server Settings</p>
                    </div>
                    <div className='my-5 text-xl font-medium p-2'>
                        3. Enjoy
                        <p className='font-light text-base ms-3'>After following the first two steps, go to the playground page and it should automatically be offline if not then click the online/offline toggle and it should work. Have Fun!</p>
                    </div>
                </div>
                <div className={"bg-dark-blue/40 rounded-lg flex flex-col p-5 w-full mx-auto my-20"}>
                    <div className='text-2xl font-bold'>
                    Available Schedulers (samplers)
                    <div className="my-8 flex flex-col">
                            <div className='mb-10 text-xl font-medium p-2'>
                                Linear Multistep Schedule
                                <p className='font-light text-base'>A linear multistep schedule is a way of controlling the learning rate of an AI model during training. It is a type of learning rate schedule that uses a linear combination of the previous N learning rates to compute the current learning rate.</p>
                            </div>
                            <div className='mb-10 text-xl font-medium p-2'>
                                Denoising Diffusion Implicit
                                <p className='font-light text-base'>Denoising diffusion implicit (DDI) is a deep learning model architecture that can be used for image generation and restoration. It involves diffusing noise into an image, and then training a deep neural network to predict the original image from the noisy version. The network is trained using an implicit generative model, which allows it to generate high-quality images with less noise than traditional methods.</p>
                            </div>
                            <div className='mb-10 text-xl font-medium p-2'>
                                DPM Solver
                                <p className='font-light text-base'>The DPM solver is a mathematical optimization algorithm that can be used to solve problems in computer vision, including object detection and tracking. It is based on a dynamic programming approach and is designed to be fast and efficient even for large-scale problems.</p>
                            </div>
                            <div className='mb-10 text-xl font-medium p-2'>
                                Euler 2
                                <p className='font-light text-base'>Euler 2 is a numerical integration method that can be used to simulate the behavior of a system over time. It is based on the Euler method but uses a more accurate approximation to the derivative of the system.</p>
                            </div>
                            <div className='mb-10 text-xl font-medium p-2'>
                                Ancestral Euler
                                <p className='font-light text-base'>Ancestral Euler is a variant of the Euler method that is used in probabilistic modeling and Bayesian inference. It involves sampling from the joint distribution of the variables in a probabilistic model, and then using the samples to compute the posterior distribution.</p>
                            </div>
                            <div className='mb-10 text-xl font-medium p-2'>
                                Denoising Diffusion Probabilistic
                                <p className='font-light text-base'>The Denoising Diffusion Probabilistic scheduler is a parameterized Markov chain trained using variational inference to produce samples matching the data after a finite time. Transitions of this chain are learned to reverse a diffusion process, which is a Markov chain that gradually adds noise to the data in the opposite direction of sampling until the signal is destroyed. When the diffusion consists of small amounts of Gaussian noise, it is sufficient to set the sampling chain transitions to conditional Gaussians too, allowing for a particularly simple neural network parameterization</p>
                            </div>  
                            <div className='text-xl font-medium p-2'>
                                Pseudo Numerical
                                <p className='font-light text-base'>Pseudo numerical methods are a class of numerical methods that use pseudo-random numbers to approximate the solution of a mathematical problem. They are often used in computer simulations and other applications where exact solutions are difficult or impossible to compute. Pseudo numerical methods are less accurate than true numerical methods but are often faster and more efficient.</p>
                            </div>                    
                    </div>
                    </div>
                </div>
                
                <div className={"bg-dark-blue/40 rounded-lg flex flex-col p-5 w-full mx-auto my-20"}>
                    <h2 className='text-2xl font-bold'>Need Help? Join Our Community</h2>
                    <div className='my-5 text-xl font-medium p-2'>
                        Get Support on Discord
                        <p className='font-light text-base ms-3'>
                            Join our Discord community to get support, share your creations, and connect with other users. 
                            Our team and community members are there to help answer your questions.
                        </p>
                        <div className="mt-4">
                            <button 
                                onClick={() => {
                                    if (electronBridge.isElectron) {
                                        electronBridge.ipcRenderer.send("open-urlInExternal", 'https://discord.com/invite/gTTKzXKNay');       
                                    } else {
                                        window.open('https://discord.com/invite/gTTKzXKNay', '_blank')
                                    }
                                }}
                                className="py-2 px-4 border rounded bg-indigo-600 hover:bg-indigo-700 transition text-white flex items-center"
                            >
                                <SiDiscord className="mr-2" size={24} />
                                Join Our Discord Support Server
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <div id='footer' className='sticky flex flex-row w-full backdrop-blur-3xl h-52'>
                <div className='h-full w-full flex flex-col justify-start items-center'>
                    <p className='mt-8 text-xl font-bold'>Like what you see here?</p>
                    <p className='w-4/5 text-lg text-center'>If you need help or need any technical assistance regarding this tool, please email <a className='text-yellow font-bold' href="mailto:help@promptus.ai">help@promptus.ai</a>.</p>
                </div>
                <div className='h-full w-full flex flex-col justify-start items-center'>
                    <p className='mt-8 text-xl font-bold'>Create, Build, and Compute</p>
                    <p className='w-4/5 text-lg text-center'>Stay up-to-date with the Promptus AI creator tips, AI workflows, models announcements and news.</p>
                    <div className='flex flex-row gap-3 mt-4'>
                        <a rel='noopener noreferrer' onClick={() => openExternalUrl("https://www.linkedin.com/company/100269/")}>
                            <SiLinkedin size={38}/>
                        </a>
                        <a rel='noopener noreferrer' onClick={() => openExternalUrl("https://www.facebook.com/people/Promptusai/100090640903722/")}>
                            <SiFacebook size={38} />
                        </a>
                        <a rel='noopener noreferrer' onClick={() => openExternalUrl("https://www.instagram.com/promptus.ai/")}>
                            <SiInstagram size={38}/>
                        </a>
                        <a rel='noopener noreferrer' onClick={() => openExternalUrl("https://www.x.com/promptus_ai")}>
                            <SiTwitter size={38}/>
                        </a>
                        <a rel='noopener noreferrer' onClick={() => openExternalUrl("https://www.tiktok.com/@promptus.ai")}>
                            <SiTiktok size={38}/>
                        </a>
                        <a rel='noopener noreferrer' onClick={() => openExternalUrl("https://discord.com/invite/gTTKzXKNay")}>
                            <SiDiscord size={38}/>
                        </a>
                    </div>
                </div>
                {/* <div className='h-full w-full flex flex-col justify-start items-center'>
                    <p className='mt-8 text-xl font-bold'>Links</p>
                    <p className='w-4/5 text-lg text-center'>Discord</p>
                </div> */}
            </div>
        </>
    );
}
